import { useQuery } from '@tanstack/react-query'
import { searchApi } from '@/api/searchApi'
import type { Panel } from '@/types/panels'
import type { BendingMomentCapacitySearchParams, SectionModulusSearchParams } from '@/types/search'

// Search panels by bending moment capacity
export const usePanelsByBendingMomentCapacity = (
  params: BendingMomentCapacitySearchParams | undefined,
  enabled = true,
) => {
  return useQuery<Panel[], Error>({
    queryKey: ['panels', 'search', 'bending_moment_capacity', params],
    queryFn: () => {
      if (!params?.bmc) {
        throw new Error('Bending moment capacity value is required')
      }
      return searchApi.searchByBendingMomentCapacity(params)
    },
    enabled: enabled && !!params?.bmc,
  })
}

// Search panels by section modulus
export const usePanelsBySectionModulus = (
  params: SectionModulusSearchParams | undefined,
  enabled = true,
) => {
  return useQuery<Panel[], Error>({
    queryKey: ['panels', 'search', 'section_modulus', params],
    queryFn: () => {
      if (!params?.sm) {
        throw new Error('Section modulus value is required')
      }
      return searchApi.searchBySectionModulus(params)
    },
    enabled: enabled && !!params?.sm,
  })
}
